import { TileIndex } from "../../types";

export const IT_FLOATS: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1],
  [1, 0, 2, 2, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 26, 2, 15, 1],
  [1, 0, 2, 30, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
  [1, 0, 2, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 16, 16, 25, 1],
  [1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 22, 22, 22, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]